import { render, staticRenderFns } from "./MealInfo.vue?vue&type=template&id=3fac6c75&scoped=true&"
import script from "./MealInfo.vue?vue&type=script&lang=js&"
export * from "./MealInfo.vue?vue&type=script&lang=js&"
import style0 from "./MealInfo.vue?vue&type=style&index=0&id=3fac6c75&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fac6c75",
  null
  
)

export default component.exports